import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { toast, ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import backgroundImage from '../assets/pngtree-scene-with-geometrical-forms-the-poster-model-minimal-background-render-image_452981.jpg';
import logoImage from '../assets/GX Transparent logo.png';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';

const SignInExitsCandidate = () => {
  const [submitted, setSubmitted] = useState(false);
  const [cookies, setCookie] = useCookies(['user']);
  const navigate = useNavigate();

  const schema = yup.object().shape({
    email: yup.string().required('Email is required').email('Email is invalid'),
    password: yup.string().required('Password is required').min(8, 'Password must be at least 8 characters'),
  });

  const { register, handleSubmit, formState: { errors }, reset } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    try {
      const response = await fetch('http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/SIgnInExitsCandidate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const responseData = await response.json();

      if (response.ok) {
        setCookie('authToken', responseData.token, { path: '/', maxAge: 3974400 });
        setCookie('userid', responseData.user._id, { path: '/' });
        toast.success('Sign In Successfully', {
          position: 'top-center',
          transition: Slide,
        });
        reset();
        setSubmitted(true);
      } else {
        toast.error(responseData.message || 'Failed to sign in. Please check your email and password.');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Failed to sign in. Please try again later.');
    }
  };

  useEffect(() => {
    if (submitted) {
      const timer = setTimeout(() => {
        navigate('/DisplayExitsCandidateDetails');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [submitted, navigate]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <ToastContainer />
      <img src={logoImage} alt="Logo" className="absolute top-1 left-4 w-52 h-32" />
      
      <div className="bg-white bg-opacity-10 p-8 mt-12 rounded-xl shadow-lg max-w-md w-full">
        {/* <h2 className="text-3xl font-bold text-center text-primary-dark">Exits Employee Portal</h2> */}
        <h2 className="text-3xl font-bold mb-6 text-center text-primary-dark">GX Exit Hub</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <label className="block text-neutral-dark mb-2 font-medium" htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              {...register('email')}
              className="w-full px-4 py-2 border border-neutral-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              required
            />
            {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>}
          </div>
          <div className="mb-6">
            <label className="block text-neutral-dark mb-2 font-medium" htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              {...register('password')}
              className="w-full px-4 py-2 border border-neutral-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              required
            />
            {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password.message}</p>}
          </div>
          <button
            type="submit"
            className="w-full bg-primary text-white pb-2 py-2 rounded-lg hover:bg-primary-dark transition duration-300"
          >
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default SignInExitsCandidate;
